import * as React from "react";
const SvgFiRrRouteHighway = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-route-highway_svg__a)">
      <path
        fill="#062147"
        d="M20 10c0-.804.626-1.64 1.178-2.378l.154-.208a3.44 3.44 0 0 0 .543-2.974c-.41-1.491-1.885-2.417-3.852-2.417-.576 0-1.775-.038-2.006-.023-.601-.011-1.061-.412-1.592-.876a9 9 0 0 0-.744-.6 2.95 2.95 0 0 0-3.365.002c-.247.169-.491.38-.743.6-.531.467-.99.869-1.591.88 0 0-1.585.03-2.02.03-1.53 0-3.382.749-3.84 2.417a3.41 3.41 0 0 0 .54 2.952l.147.196c.558.743 1.189 1.585 1.189 2.398 0 .764-.435 1.633-.895 2.553-.543 1.087-1.105 2.21-1.105 3.447 0 4.843 5.116 6.605 7.864 7.552q.432.147.79.278c.433.158 1.14.17 1.346.17.146 0 .9-.008 1.356-.174.233-.085.494-.175.774-.271 2.75-.947 7.869-2.71 7.869-7.554 0-1.236-.563-2.36-1.105-3.447-.46-.92-.895-1.79-.895-2.553zM4.06 4.958c.163-.594 1.23-.922 1.904-.922.444 0 2.054-.03 2.054-.03 1.333-.024 2.224-.805 2.874-1.375.19-.167.372-.33.558-.457a.97.97 0 0 1 .552-.175c.19 0 .38.058.55.174.187.128.368.29.559.457.65.568 1.542 1.346 2.89 1.37.24 0 1.43.023 2.024.023.277 0 1.676.045 1.922.945.12.438.037.907-.221 1.256l-.148.2c-.334.447-.731.977-1.043 1.58L5.468 7.999c-.315-.611-.717-1.147-1.056-1.6l-.141-.187c-.253-.341-.334-.801-.21-1.255m9.42 16.705c-.293.1-.565.195-.794.279-.19.053-1.2.047-1.345.01a43 43 0 0 0-.826-.29C7.218 20.526 3.999 19.152 3.999 16c0-.764.435-1.633.895-2.553.543-1.087 1.105-2.211 1.105-3.447l12 .004c0 1.234.563 2.357 1.105 3.443.46.92.895 1.789.895 2.553 0 3.154-3.22 4.527-6.52 5.663"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-route-highway_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRouteHighway;
